// extracted by mini-css-extract-plugin
export var card = "DirectionCard-module--card--64732";
export var title = "DirectionCard-module--title--2507f";
export var list = "DirectionCard-module--list--7d18b";
export var software = "DirectionCard-module--software--3061e";
export var button = "DirectionCard-module--button--6f341";